<template>
  <div class="d-flex justify-content-between flex-column w-100 mt-1">
    <label class="fs-14 font-mont fw-500 color-darkblack"
      >{{ label }}<span v-show="isMandatory" class="asterik">*</span></label
    >
    <!-- newmodalinputbox instead of topdiv -->
    <div class="w-100">
      <div
        class="date-floating-label topDiv"
        @mouseover="hovering = true"
        @mouseleave="hovering = false"
      >
        <!-- nothing except w-100 n pointer -->
        <DatePicker
          class="datefield-input w-100"
          :class="{ dateerror: error }"
          :placeholder="placeholder"
          v-model="localDate"
          @change="onDateChange"
          @input="handleInput"
          :format="dateFormat"
          :value-type="dateType"
          :type="fieldType"
          :disabled-date="disabledDates"
          :disabled-time="disabledTime"
          :disabled="disabled"
        />

        <img
          :class="disabled ? 'disable-cursor' : 'pointer'"
          class="kanban-calendar-icons"
          src="@/assets/images/PanelImages/SelectTest/time.svg"
          alt=""
          @click="openDatePicker"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DateField",
  data() {
    return {
      localDate: "",
      hovering: false,
      isFocused: false,
    };
  },
  props: {
    vmodel: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Label",
    },
    isMandatory: {
      type: Boolean,
      default: true,
    },
    dateType: {
      type: String,
      default: "YYYY-MM-DDTHH:mm:ss.SSS[Z]",
    },
    dateFormat: {
      type: String,
      default: "DD-MM-YYYY HH-mm",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    
    error: {
      type: Boolean,
      default: false,
    },
    fieldType: {
      type: String,
      default: "datetime",
    },
    id: {
      type: String,
      default: "",
    },
    startDate: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "Select",
    },
    disablePaste: { type: Boolean, default: false },
  },
  watch: {
    localDate(newValue) {
      this.$emit("update-value", newValue);
    },
    vmodel(newValue) {
      this.localDate = newValue;      
    },
  },
   mounted() {
    // Attach paste/typing prevention if prop is true
    if (this.disablePaste) {
      const input = this.$el.querySelector(".mx-input");
      if (input) {
        input.onpaste = (e) => e.preventDefault();
        input.onkeydown = (e) => {
          // prevent manual typing (optional)
          if (
            e.key.length === 1 || // printable characters
            (e.ctrlKey && ["v", "V"].includes(e.key)) // Ctrl+V
          ) {
            e.preventDefault();
          }
        };
      }
    }
  },
  created() {
    if (this.vmodel) {
      this.localDate = this.vmodel;
    }
  },
  methods: {
    onDateChange(date) {

      this.localDate = date;
    },
    disabledDates(date) {
      if (this.id === "disableFromConfig") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date < today;
      }
      if (this.id === "disableToConfig") {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (this.startDate) {
          const start = new Date(this.startDate);
          start.setHours(0, 0, 0, 0);
          return date < start || date < today;
        }
        return date < today;
      }
    },
    disabledTime(date) {
      const currentTime = new Date();
      const selectedDate = new Date(date);
      selectedDate.setSeconds(0);
      selectedDate.setMilliseconds(0);
      if (selectedDate.getTime() <= currentTime.getTime()) {
        return true;
      }
    },
     handleInput(){
      this.$emit('update-value')
      this.$emit('select-value',this.localDate)

    },
    openDatePicker() {
    if (!this.disabled) {
      // focus the input inside DatePicker
      const input = this.$el.querySelector('.mx-input');
      if (input) input.focus();
    }
  },
 
  },
};
</script>

<style>
.topDiv .datefield-input .mx-input {
  box-sizing: border-box;
  padding: 3px 14px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  height: 36px;
}

.kanban-calendar-icons {
  position: absolute;
  right: 25px;
  top: 42px;
}
.datefield-input > .mx-input-wrapper > .mx-icon-calendar {
  display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear {
  display: none;
}

.datefield-input > .mx-input-wrapper > .mx-icon-clear:hover {
  display: none;
}

.mx-input-wrapper input::placeholder {
  color: #667085;
}

.topDiv > .dateerror .mx-input {
  border: 1px solid red !important;
  border-radius: 8px !important;
}
.topDiv > .datefield-input .mx-input {
  cursor: pointer;
}
.newmodalinputbox > .dateerror .mx-input {
  border: 1px solid red !important;
  border-radius: 8px !important;
}
.newmodalinputbox > .datefield-input .mx-input {
  cursor: pointer;
}

.new-calender-class {
  position: absolute;
  right: 15px;
  top: 12px;
}

.close-icon-class {
  position: absolute;
  right: 42px;
  top: 12px;
}

.topDiv > .datefield-input .mx-input:disabled {
  background: rgba(140, 140, 140, 0.15) !important;
  cursor: not-allowed;
}
.date-floating-label label {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 12px;
  color: #667085;
  font-weight: 400;
  font-family: "Lato", sans-serif;
  transition: all 0.2s ease;
  pointer-events: none;
}
.disable-cursor {
  cursor: not-allowed !important;
}

.date-floating-label label.active {
  top: -10px;
  left: 13px;
  font-size: 13px;
  color: #667085;
  font-weight: 400;
  font-family: "Lato", sans-serif;
  background-color: #ffffff;
}
@media (max-width: 1028px) {
  .mx-input::placeholder {
    color: #ffffff !important;
  }
}
</style>
